export const CONVENCION = {
  iut: '60100003-2'
};

export const GORE_VALPARAISO = {
  iut: '72235100-2'
};

export const MACHALI = {
  iut: '69080200-7',
};

export const MOP = {
  iut: '61202000-0'
};

export const SISS = {
  iut: '61221000-4'
};

export const INH = {
  iut: '61211000-K'
  // iut: '76179952-5'
};

export const SERCOTEC = {
  iut: '82174900-K'
};

export const AGUAS_ANDINAS = {
  iut: '61808000-5'
};

export const SAVAL = {
  iut: '91650000-9'
};

export const U_AYSEN = {
  iut: '61980520-8',
};
